import React, { SVGProps } from 'react';

const CardDiscover: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 64 64'
        width={24}
        height={24}
        {...props}
    >
        <path
            d='M11.58 43.6h43.21c1.145 0 2.09-.946 2.09-2.09V26.873c-4.182 2.639-19.813 11.699-45.3 16.727z'
            fill='#F58220'
        />
        <path
            d='M26.414 21.05c-1.742 0-3.136 1.344-3.136 2.987 0 1.742 1.344 3.086 3.136 3.086 1.743 0 3.087-1.344 3.087-3.037 0-1.692-1.344-3.036-3.087-3.036z'
            fill='url(#discover-a)'
        />
        <path
            d='M8.693 21.15H7v5.824h1.643c.896 0 1.543-.2 2.09-.697a2.992 2.992 0 0 0 1.046-2.24c.05-1.693-1.244-2.888-3.086-2.888zm1.344 4.38c-.349.348-.846.448-1.543.448h-.299v-3.883h.299c.746 0 1.194.15 1.543.448.398.349.647.896.647 1.444 0 .647-.249 1.195-.647 1.543zm3.484-4.38h-1.145v5.824h1.145v-5.825zm2.789 2.24c-.698-.25-.897-.399-.897-.747 0-.349.348-.647.846-.647.349 0 .598.149.896.448l.598-.797C17.255 21.2 16.657 21 16.01 21c-1.045 0-1.841.697-1.841 1.692 0 .797.348 1.195 1.443 1.593.448.15.697.25.797.349.248.15.348.348.348.597 0 .498-.398.846-.896.846-.548 0-.995-.248-1.244-.796l-.747.697c.547.747 1.145 1.095 2.04 1.095 1.195 0 1.992-.796 1.992-1.941.05-.847-.299-1.245-1.593-1.743zm2.04.696c0 1.742 1.344 3.037 3.086 3.037.498 0 .896-.1 1.444-.349V25.43c-.448.448-.846.647-1.394.647-1.145 0-1.941-.846-1.941-1.99 0-1.096.846-1.992 1.891-1.992.548 0 .946.2 1.444.647v-1.344c-.498-.249-.896-.348-1.394-.348-1.792-.05-3.136 1.344-3.136 3.036zm13.74.996-1.594-3.933h-1.244l2.489 5.974h.647l2.489-5.974h-1.245l-1.543 3.933zm3.334 1.892h3.236v-.946h-2.09v-1.593h1.99v-.996h-1.99v-1.294h2.09v-.996h-3.236v5.825zm7.716-4.082c0-1.095-.746-1.743-2.09-1.743h-1.693v5.825h1.145v-2.34h.15l1.592 2.34h1.394l-1.842-2.44c.896-.199 1.344-.746 1.344-1.642zm-2.29.945h-.298v-1.791h.348c.697 0 1.095.298 1.095.846 0 .647-.398.945-1.145.945z'
            fill='#001722'
        />
        <path
            d='M43.937 21.597c0-.1-.05-.15-.2-.15h-.149v.498h.1v-.199l.149.2h.15l-.15-.2c.1-.05.1-.1.1-.149zm-.2.05v-.15c.05 0 .1 0 .1.05 0 .1-.05.1-.1.1z'
            fill='#231F20'
        />
        <path
            d='M43.787 21.249c-.249 0-.448.2-.448.448 0 .249.2.448.448.448.25 0 .448-.2.448-.448a.446.446 0 0 0-.448-.448zm0 .797a.34.34 0 0 1-.348-.349c0-.2.15-.348.348-.348.2 0 .349.149.349.348 0 .2-.15.349-.349.349z'
            fill='#231F20'
        />
        <defs>
            <radialGradient
                id='discover-a'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(26.386 24.085) scale(3.07686)'
            >
                <stop offset='.006' stopColor='#FFEEE0' />
                <stop offset='.11' stopColor='#FEE9D7' />
                <stop offset='.279' stopColor='#FDDBBF' />
                <stop offset='.493' stopColor='#FBC597' />
                <stop offset='.744' stopColor='#F8A560' />
                <stop offset='1' stopColor='#F48120' />
            </radialGradient>
        </defs>
    </svg>
);

export default CardDiscover;
